import { SAVE_LAST_QUERY } from '../type';

export const saveLastQuery = (payload) => ({
  type: SAVE_LAST_QUERY,
  payload,
});
